import { createSelector } from 'reselect'

export default createSelector(
  (state: any) => state?.checkout?.partex?.vrm,
  (vrm: string | undefined) => vrm,
)
